import * as React from 'react';
import { IBaseProps } from '../../types/props';

import { logGAPageView } from '../../utils/google-analytics';

interface IWelcomeProps extends IBaseProps {
  history: {
    push: (url: string) => void;
  };
}

export class Welcome extends React.PureComponent<IWelcomeProps, any> {
  constructor(props) {
    super(props);
    window.location.href = 'https://marquee.gs.com/welcome/';
  }
  componentDidMount() {
    logGAPageView();
  }

  render() {
    return <div />;
  }
}
